export default "__VITE_ASSET__BbWVmvAd__"